import { Text } from '@/utils';

export const props = {
    props:
    {
        error:
        {
            type: String,
            default: null,
        },

        label:
        {
            type: String,
            default: null,
        },

        cols:
        {
            type: Number,
            default: 30,
        },

        rows:
        {
            type: Number,
            default: 5
        },

        value: [String, Number],

        modelValue: [String, Number],

        width:
        {
            type: String,
            default: null, // 'xsmall', 'small', 'medium', 'large', '1-*'
        },

        margin:
        {
            type: Boolean,
            default: true,
        },

        size:
        {
            type: String,
            default: null, // 'small', 'large'
        },

        divClass:
        {
            type: String,
            default: ''
        },

        loading:
        {
            type: Boolean,
            default: false,
        }
    },
};

export const computed = {
    computed:
    {
        listeners()
        {
            const vm = this;

            return Object.assign({},
                this.$listeners,
                {
                    input: (event) =>
                    {
                        vm.$emit('input', event.target.value);
                    },

                    change: (event) =>
                    {
                        vm.$emit('onchange', event.target.value);
                    },
                }
            );
        },

        wrapperClasses()
        {
            return Text.joinClass(
                this.margin && 'vh-margin'
            );
        },

        classes()
        {
            return Text.joinClass(
                'vh-textarea vh-textarea-message',
                this.error && 'vh-form-danger'
            );
        },

        labelClasses()
        {
            return Text.joinClass(
                'vh-form-label',
                'vh-text-bold',
                this.error && 'vh-text-danger',
            );
        },
    },
};
